
















































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";

@Component
export default class WorkComponent extends Vue {
  public overlayClass = "work-overlay--hidden";
  public imageToDisplay = "";
  public showMore = false;

  public openOverlay(src: string) {
    this.overlayClass = "work-overlay";
    this.imageToDisplay = src;
  }

  public closeOverlay() {
    this.overlayClass = "wow fadeOut animated";
    setTimeout(this.hideAfter, 1500);
  }

  public hideAfter() {
    this.overlayClass = "work-overlay--hidden";
  }

  @Watch('this.$i18n.locale')
  public showMoreExamples() {
    this.showMore = !this.showMore;
  }
}
